import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { actionUpdateFlowType } from 'src/app/v1/state/modules/formData/flowType';
import type { AppState } from 'src/types/appState';
import type { FlowType } from 'src/types/jobFlow';

export const useFlowType = (type: FlowType) => {
  const { isDataCleanupComplete } = useSelector(
    (state: AppState) => ({
      isDataCleanupComplete: state.app?.isDataCleanupComplete,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (isDataCleanupComplete) {
      dispatch(actionUpdateFlowType(type));
    }
  }, [dispatch, isDataCleanupComplete, type]);
};
